import { Injectable, NgZone } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';

@Injectable({ providedIn: 'root' })
export class SocketService {
  private socket: Socket | null = null;
  private readonly eventSubjects = new Map<string, Subject<unknown>>();

  constructor(private readonly ngZone: NgZone) {}

  public connect(token: string): void {
    this.disconnect();

    this.ngZone.runOutsideAngular(() => {
      this.socket = io(environment.apiUrl, {
        auth: { token },
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 1000,
      });
    });
  }

  public disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }

    this.eventSubjects.forEach(subject => subject.complete());
    this.eventSubjects.clear();
  }

  public reconnect(token: string): void {
    this.connect(token);
  }

  public on<T>(event: string): Observable<T> {
    let subject = this.eventSubjects.get(event) as Subject<T> | undefined;

    if (!subject) {
      subject = new Subject<T>();
      this.eventSubjects.set(event, subject as Subject<unknown>);

      this.socket?.on(event, (data: T) => {
        this.ngZone.run(() => subject!.next(data));
      });
    }

    return subject.asObservable();
  }

  public get connected(): boolean {
    return this.socket?.connected ?? false;
  }
}
